import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { AuthData } from '@app/core/auth/authentication/types';
import { useUiStore } from '@app/core/ui/stores/ui.store';
import React from 'react';
import { useTimezone } from '../../../core/hooks/index';
import { SidenavP } from './SidenavP';

export interface Props {
  auth: AuthData;
  collapsed: boolean;
  timezone: string | null;
  children?: React.ReactNode;
}

export function Sidenav(p: { children?: React.ReactNode }) {
  const isExpanded = useUiStore((state) => state.sidenavOpen);
  const auth = useAuth();
  const tz = useTimezone();

  return (
    <SidenavP auth={auth} collapsed={!isExpanded} timezone={tz}>
      {p.children}
    </SidenavP>
  );
}
